module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs-pane"
  }, [_c('div', {
    staticClass: "item",
    class: {
      active: _vm.show, haschild: _vm.list.children && _vm.list.children.length
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [(_vm.isRadio ? _vm.list.children.length : (_vm.list.userInfos.length || _vm.list.children.length)) ? _c('div', {
    staticClass: "g-sanjiao",
    style: ({
      transform: _vm.show ? 'rotate(180deg)' : 'rotate(0)'
    })
  }) : _vm._e(), _vm._v(" "), (_vm.isRadio && _vm.$store.state.chooseBranch.id !== _vm.list.id) ? _c('i', {
    staticClass: "iconfont icon-dianxuanweixuan",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.chooseRadio(_vm.list)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isRadio && _vm.$store.state.chooseBranch.id === _vm.list.id) ? _c('i', {
    staticClass: "iconfont icon-dianxuanxuanzhong"
  }) : _vm._e(), _vm._v(" "), _vm._v("\n    " + _vm._s(_vm.list.label) + "\n  ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }]
  }, [_vm._l((_vm.list.userInfos), function(cel, index) {
    return (!_vm.isRadio) ? _c('v-checkbox', {
      key: cel.userInfoId,
      attrs: {
        "item": cel
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.list.children), function(cel, index) {
    return _c('v-tabsPane', {
      key: cel.label,
      attrs: {
        "list": cel,
        "isRadio": _vm.isRadio,
        "closeChoose": _vm.closeChoose
      }
    })
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-51caf256"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs-pane.vue
// module id = 224
// module chunks = 49